var map = {
	"./Canvas.vue": 22211,
	"./DocumentIframe.js": 706,
	"./Gallery.vue": 76643,
	"./ModeAndViewportToolbar.vue": 72580,
	"./ToolbarTop.vue": 93917,
	"./VersionActions.vue": 72714,
	"./resizableMargin.js": 6204,
	"./tooltip.js": 65780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10571;